module.exports = "/_next/static/resources/photo-3-d42cd27dc664e927e8dee9f3954447d6.jpg";